import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { PaddedDialog } from './styles'

interface DeleteProductModalProps {
	modalOpen: boolean
	onClose: () => void
	onSubmit: () => void
}

const DeleteProductModal = (props: DeleteProductModalProps) => {
	const { modalOpen, onClose, onSubmit } = props
	const { t } = useTranslation()

	return (
		<PaddedDialog open={modalOpen} onClose={onClose}>
			<Typography variant="h2">
				{t('modal.delete.textProductFromCatalogue')}
			</Typography>
			<Box mt={4} display="flex" justifyContent="space-around">
				<Button
					className="add-product-modal-cancel-button"
					variant="outlined"
					color="primary"
					onClick={onClose}
				>
					{t('button.cancel')}
				</Button>
				<Button variant="contained" color="primary" onClick={onSubmit}>
					{t('button.yes')}
				</Button>
			</Box>
		</PaddedDialog>
	)
}

export { DeleteProductModal }
